import { createFileRoute } from '@tanstack/react-router';

import { SetPasswordPage } from '@/features/auth/pages/SetPasswordPage';

export const Route = createFileRoute('/set-password')({
  component: SetPasswordPage,
  validateSearch: (search: Record<string, unknown>) => ({
    token: (search.token as string) ?? '',
  }),
});
